import { render } from "./ScanView.vue?vue&type=template&id=4167dd6b"
import script from "./ScanView.vue?vue&type=script&lang=js"
export * from "./ScanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__